import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=002f682c&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=002f682c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f682c",
  null
  
)

export default component.exports